import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkerIndependent = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "workerIndependent",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12455",
			"data-name": "Path 12455",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12456",
			"data-name": "Path 12456",
			d: "M16,21H8a2,2,0,0,1-2-2V5A2,2,0,0,1,8,3h8a2,2,0,0,1,2,2V19A2,2,0,0,1,16,21Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12457",
			"data-name": "Path 12457",
			d: "M12,17.25a.25.25,0,1,0,.251.25A.249.249,0,0,0,12,17.25",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12458",
			"data-name": "Path 12458",
			d: "M10.75,6h2.5",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgWorkerIndependent;
